module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point02/th_02-7e7fb924a54276c0847424d6158c1749.jpg";